import type { VoidFunctionComponent } from 'react';

import { SNIPPET_SOURCE_CODE_RETENTION_DAYS_ERROR } from '../../../../../shared/organizations/errors';
import { isFreeTier } from '../../../../../shared/subscriptions';
import { window } from '../../../../globals';
import { ErrorAlert, FormGroup } from '../../../generic';
import PaidFeatureGate from '../../../generic/Gates/PaidFeatureGate';
import Text from '../../../generic/Text';
import LabeledNumberInputWithUnit from '../../shared/LabeledNumberInputWithUnit';
import type { GeneralSettings } from '../../../../../shared/settings/general';

type Props = {
  settings: GeneralSettings;
  onUpdateSettings: (settings: Partial<GeneralSettings>) => void;
  isDisabled: boolean;
  errors: string[] | null;
};

/**
 * Displays the snippets section of the general settings page.
 */
const SnippetsSection: VoidFunctionComponent<Props> = ({
  settings,
  onUpdateSettings,
  isDisabled,
  errors,
}) => {
  return (
    <>
      <Text.H3>Snippets</Text.H3>
      <PaidFeatureGate isRestricted={isFreeTier({
        plan: window.user?.organization?.stripe_plan,
        stripePriceLimit: window.user?.organization?.stripePriceLimit,
      })}>
        {errors?.some((error) => error.includes(SNIPPET_SOURCE_CODE_RETENTION_DAYS_ERROR)) && (
          <ErrorAlert status={{ errors }} />
        )}
        <div>
          <FormGroup>
            <LabeledNumberInputWithUnit
              unit="days"
              label="Source Code Retention"
              value={settings.snippetSourceCodeRetentionDays}
              onChange={(snippetSourceCodeRetentionDays: number) =>
                onUpdateSettings({
                  snippetSourceCodeRetentionDays,
                })}
              isDisabled={isDisabled}
            />
          </FormGroup>
        </div>
      </PaidFeatureGate>
    </>
  );
};

export default SnippetsSection;
